import { normalize } from 'normalizr';

import commonActions from './common';
import { post, update, deleteEntity } from '../utils/communications';
import { apiEndpoint } from '../utils/env';
import usersSchema from '../normalizr-schemas/usersSchema';

const usersConfigActions = commonActions('users');

export const createNewUser = ({ email, role }) => (dispatch, getState) => {
  dispatch(usersConfigActions.submitAddItem());
  const body = {
    data: {
      type: 'users',
      attributes: {
        organisationId: getState().currentOrganisation,
        email,
        role,
      },
    },
  };

  post(`${apiEndpoint}/users`, body)
    .then((res) => {
      if (res.data) {
        const normalizedData = normalize(res.data.attributes.newUser, usersSchema);
        dispatch(usersConfigActions.storeItems('users', normalizedData));
      }
      return dispatch(usersConfigActions.closeNewModal());
    });
};

export const updateUser = (id, newRole) => (dispatch, getState) => {
  dispatch(usersConfigActions.submitUpdateItem(id));
  const organisationId = getState().currentOrganisation;
  const body = {
    data: {
      type: 'users',
      attributes: {
        role: newRole,
      },
    },
  };

  update(`${apiEndpoint}/organisations/${organisationId}/users/${id}/role`, body, {}, usersSchema)
    .then(res => dispatch(usersConfigActions.updateItem('users', res.data)));
};

export const deleteUser = id => (dispatch, getState) => {
  dispatch(usersConfigActions.submitDeleteItem(id));
  const organisationId = getState().currentOrganisation;

  deleteEntity(`${apiEndpoint}/organisations/${organisationId}/users/${id}`)
    .then(() => dispatch(usersConfigActions.deleteItem(id)));
};



// WEBPACK FOOTER //
// ./src/actions/users.js